module.exports = __webpack_public_path__ + "img/bd.2f35de00.svg";